import React, { useState } from 'react';
import Navbar from '../../components/Navbar';
import '../../components/Navbar.css';
import AdminSidebar from '../../components/AdminSidebar';
import '../../components/AdminTables.css';
import { getToken } from '../../utils/auth';

function VotersAdmin() {
  const [firstName, setFirstName] = useState('');
  const [middleName, setMiddleName] = useState('');
  const [lastName, setLastName] = useState('');
  const [voters, setVoters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSearch = async () => {
    setLoading(true);
    setError(null);
    try {
      const token = getToken();
      const params = new URLSearchParams();
      if (firstName) params.append('firstName', firstName);
      if (middleName) params.append('middleName', middleName);
      if (lastName) params.append('lastName', lastName);
      const res = await fetch('/api/admin/voters?' + params.toString(), { headers: { 'x-auth-token': token } });
      if (!res.ok) {
        throw new Error('Failed to fetch');
      }
      const data = await res.json();
      setVoters(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formatName = (voter) => {
    return `${voter.FirstName || ''} ${voter.MiddleName || ''} ${voter.LastName || ''}`.trim();
  };

  const formatDOB = (dob) => {
    if (!dob) return '';
    const date = new Date(dob);
    return date.toLocaleDateString();
  };

  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <Navbar />
      <div style={{ display: 'flex', maxWidth: '1200px', margin: '8px auto', boxShadow: '0 1px 6px rgba(16,24,40,0.04)' }}>
        <AdminSidebar />
        <main style={{ flex: 1, padding: 12, background: '#fff' }}>
          <h2 style={{ marginTop: 0 }}>Search Voters</h2>

          <div style={{ display: 'flex', gap: 12, marginBottom: 12, alignItems: 'end' }}>
            <div>
              <label style={{ display: 'block' }}>First Name</label>
              <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} />
            </div>
            <div>
              <label style={{ display: 'block' }}>Middle Name</label>
              <input type="text" value={middleName} onChange={e => setMiddleName(e.target.value)} />
            </div>
            <div>
              <label style={{ display: 'block' }}>Last Name</label>
              <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} />
            </div>
            <button onClick={handleSearch} style={{ padding: '8px 16px' }}>Search</button>
          </div>

          {loading && <div>Loading...</div>}
          {error && <div style={{ color: 'red' }}>{error}</div>}

          <table className="admin-table">
            <thead>
              <tr>
                <th>VoterID</th>
                <th>Name</th>
                <th>Addr1</th>
                <th>City</th>
                <th>Zip</th>
                <th>DOB</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {voters.map(v => (
                <tr key={v.VoterID}>
                  <td>{v.VoterID}</td>
                  <td>{formatName(v)}</td>
                  <td>{v.Addr1}</td>
                  <td>{v.City}</td>
                  <td>{v.Zip}</td>
                  <td>{formatDOB(v.DOB)}</td>
                  <td>
                    <a href={`/admin/voters/${v.VoterID}`} style={{ color: '#007bff', textDecoration: 'none' }}>Details</a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </main>
      </div>
    </div>
  );
}

export default VotersAdmin;